import * as React from 'react'
import * as SwitchPrimitive from '@radix-ui/react-switch'

import { cn } from '@/lib/utils'

// The track is drawn by ::before so the button itself can grow to a 44 px tap
// target on phones without the switch looking bigger.
function Switch({ className, ...props }: React.ComponentProps<typeof SwitchPrimitive.Root>) {
  return (
    <SwitchPrimitive.Root
      data-slot="switch"
      className={cn(
        'tap-target peer relative inline-flex h-5 w-9 shrink-0 cursor-pointer items-center justify-center rounded-full transition-colors',
        'before:absolute before:top-1/2 before:left-1/2 before:h-5 before:w-9 before:-translate-x-1/2 before:-translate-y-1/2 before:rounded-full before:transition-colors before:content-[""]',
        'focus-visible:before:ring-ring/50 focus-visible:outline-none focus-visible:before:ring-[3px]',
        'disabled:cursor-not-allowed disabled:opacity-50',
        // The off track is drawn at 3:1 or more against the page, in either theme.
        'data-[state=checked]:before:bg-primary data-[state=unchecked]:before:bg-muted-foreground/80',
        className
      )}
      {...props}
    >
      <SwitchPrimitive.Thumb
        className={cn(
          'bg-background pointer-events-none absolute top-1/2 left-1/2 block h-4 w-4 -translate-y-1/2 rounded-full shadow-lg ring-0 transition-transform',
          'data-[state=checked]:translate-x-0 data-[state=unchecked]:-translate-x-4'
        )}
      />
    </SwitchPrimitive.Root>
  )
}

export { Switch }
